const tools = {
  generateKey: () => {
    const randomNumber = Math.floor(Math.random() * 100000000000000000);
    return `${randomNumber}_${new Date().getTime()}`;
  },
};

export default tools;
